import { PHONE_NO_REGEX } from 'global/appConstants';
import yup from 'utils/yup';

export const initialOrganizationDetailsFormData = {
  company: '',
  phone: '',
  industry: '' as any,
  company_size: '' as any,
  notes: '',
};

export const organizationDetailsValidationSchema = yup.object().shape({
  company: yup.string().required(),
  industry: yup.string().required(),
  company_size: yup.string().required(),
  phone: yup
    .string()
    .matches(PHONE_NO_REGEX, () => ({ msg: 'common:yup.default' }))
    .required(),
});
